import { render, staticRenderFns } from "./PhieuSuaChuaForm.vue?vue&type=template&id=07f63ff9&scoped=true&"
import script from "./PhieuSuaChuaForm.vue?vue&type=script&lang=js&"
export * from "./PhieuSuaChuaForm.vue?vue&type=script&lang=js&"
import style0 from "./PhieuSuaChuaForm.vue?vue&type=style&index=0&id=07f63ff9&style=true&media=print&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f63ff9",
  null
  
)

export default component.exports